import { render, staticRenderFns } from "./SuppressionBadge.vue?vue&type=template&id=7418f03a&scoped=true"
import script from "./SuppressionBadge.vue?vue&type=script&lang=js"
export * from "./SuppressionBadge.vue?vue&type=script&lang=js"
import style0 from "./SuppressionBadge.vue?vue&type=style&index=0&id=7418f03a&prod&lang=scss&scoped=true"
import style1 from "./SuppressionBadge.vue?vue&type=style&index=1&id=7418f03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7418f03a",
  null
  
)

export default component.exports